/**
 * Converts a field into a WordPress color picker field
 *
 * @param selector, valid jQuery selector
 */
function wp_color_picker( selector ) {
  jQuery( selector ).wpColorPicker();
}
